module.exports = __webpack_public_path__ + "static/media/draymond.91df6c5e.jpg";